import { render, staticRenderFns } from "./ClienteRoute.vue?vue&type=template&id=73d35263"
import script from "./ClienteRoute.vue?vue&type=script&lang=js"
export * from "./ClienteRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports